import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "card py-2 px-2" }
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[11] || (_cache[11] = _createElementVNode("div", null, [
      _createElementVNode("h1", null, "Pre-Approved Email Import")
    ], -1)),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.upload && _ctx.upload(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _cache[3] || (_cache[3] = _createElementVNode("div", null, "Select a Partner", -1)),
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPartner) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: partner.id,
                      key: index
                    }, _toDisplayString(partner.name), 9, _hoisted_3))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.selectedPartner]
                ])
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
              _cache[5] || (_cache[5] = _createElementVNode("div", null, "Excel File", -1)),
              _createElementVNode("input", {
                type: "file",
                id: "emailList",
                accept: ".xlsx",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onAttachment && _ctx.onAttachment(...args))),
                required: ""
              }, null, 32),
              _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
              _cache[7] || (_cache[7] = _createElementVNode("div", null, "Sample Excel file should look like this:", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("img", {
                src: "/img/excelsample.png",
                width: "300",
                height: "185",
                alt: "Sample Excel File",
                title: "Sample Excel File"
              }, null, -1)),
              _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
              _cache[10] || (_cache[10] = _createElementVNode("button", {
                class: "btn btn-primary email-button",
                type: "submit"
              }, "Upload Excel List", -1))
            ])
          ], 32)
        ]))
      : _createCommentVNode("", true),
    _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}